import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {AppComponent} from './app.component';
import {routing} from './app.routing';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {LoginComponent} from './login/login.component';
import {UserService} from './user.service';
import {PageFooterComponent} from './page-footer/page-footer.component';
import {HeaderComponent} from './header/header.component';
import {UserPageComponent} from './user-page/user-page.component';
import {
  CollapseModule,
  TabsModule,
  BsDropdownModule,
  DatepickerModule,
  BsDatepickerModule,
  AlertModule,
  ProgressbarModule
} from 'ngx-bootstrap';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {AppSettingsService} from './app-settings.service';
import {ServerService} from './server.service';
import {ServerComponent} from './server/server.component';
import {DataTableModule} from 'angular2-datatable';
import {ServerEditComponent} from './server/server-edit/server-edit.component';
import {RoleGuardService} from './role-guard.service';
import {IotComponent} from './iot/iot.component';
import {IotService} from './iot.service';
import {ChartModule} from 'angular2-highcharts';
import {ToastModule} from 'ng2-toastr';
import {NotificationService} from './notification.service';
import {CustomerComponent} from './customer/customer.component';
import {CustomerService} from './customer.service';
import {CustomerEditComponent} from './customer/customer-edit/customer-edit.component';
import {SelectModule} from 'ng2-select';
import {DatePipe, registerLocaleData} from '@angular/common';
import {LicenseService} from './license.service';
import {UserComponent} from './user/user.component';
import {PhoneNumberService} from './phone-number.service';
import {PhoneMaskDirective} from './phone-mask.directive';
import {UserEditComponent} from './user/user-edit/user-edit.component';
import {WebDialerComponent} from './web-dialer/web-dialer.component';
import {DialerService} from './dialer.service';
import {DialBoxComponent} from './dial-box/dial-box.component';
import {CallStatusBoxComponent} from './call-status-box/call-status-box.component';
import {HmsPipe} from './hms.pipe';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TokenInterceptor} from './token.interceptor';
import {ChangePassComponent} from './change-pass/change-pass.component';
import {CallLogService} from './call-log.service';
import {CallHistoryComponent} from './call-history/call-history.component';
import {BillingDashboardComponent} from './billing-dashboard/billing-dashboard.component';
import {CostCenterComponent} from './cost-center/cost-center.component';
import {CostCenterService} from './cost-center.service';
import {CostCenterEditComponent} from './cost-center/cost-center-edit/cost-center-edit.component';
import {DepartmentComponent} from './department/department.component';
import {DepartmentEditComponent} from './department/department-edit/department-edit.component';
import {DepartmentService} from './department.service';
import { ExtensionComponent } from './extension/extension/extension.component';
import {ExtensionService} from './extension.service';
import { ExtensionEditComponent } from './extension/extension-edit/extension-edit.component';
import { TariffClassComponent } from './tariff-class/tariff-class.component';
import { TariffClassEditComponent } from './tariff-class/tariff-class-edit/tariff-class-edit.component';
import {TariffClassService} from './tariff-class.service';
import { DetailedCallsComponent } from './billing/detailed-calls/detailed-calls.component';
import {ReportService} from './report.service';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import { CallLogFilterComponent } from './call-log-filter/call-log-filter.component'
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {Ng2GoogleChartsModule} from 'ng2-google-charts';
import localePtBr from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import {AccountCodeService} from './account-code.service';


const options: any = {
  animate: 'fade',
  positionClass: 'toast-top-right',
};

registerLocaleData(localePtBr, 'pt-BR', localePtExtra);

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginComponent,
    PageFooterComponent,
    HeaderComponent,
    UserPageComponent,
    SideMenuComponent,
    ServerComponent,
    ServerEditComponent,
    IotComponent,
    CustomerComponent,
    CustomerEditComponent,
    UserComponent,
    UserEditComponent,
    PhoneMaskDirective,
    WebDialerComponent,
    DialBoxComponent,
    CallStatusBoxComponent,
    HmsPipe,
    ChangePassComponent,
    CallHistoryComponent,
    BillingDashboardComponent,
    CostCenterComponent,
    CostCenterEditComponent,
    DepartmentComponent,
    DepartmentEditComponent,
    ExtensionComponent,
    ExtensionEditComponent,
    TariffClassComponent,
    TariffClassEditComponent,
    DetailedCallsComponent,
    CallLogFilterComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressbarModule.forRoot(),
    HttpModule,
    routing,
    CollapseModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AlertModule.forRoot(),
    DataTableModule,
    ChartModule,
    ToastModule.forRoot(),
    SelectModule,
    TabsModule.forRoot(),
    DatepickerModule.forRoot(),
    NgxDatatableModule,
    NgxChartsModule,
    Ng2GoogleChartsModule,
  ],
  providers: [UserService, AppSettingsService, ServerService, RoleGuardService, NotificationService, CustomerService,
    IotService, DatePipe, LicenseService, PhoneNumberService, DialerService, CallLogService, CostCenterService,
    DepartmentService, ExtensionService, TariffClassService, ReportService, AccountCodeService,
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true}, {provide: LOCALE_ID, useValue: 'pt-BR'}
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/app.module.ts